import { retrieveErrorFromApi } from '../../../helper'
import { logger } from '../../../logger/logger'
import { setAppErrors } from '../../action/system'
import getNotificationDevice from '../../axios/posNotification/devices/get'
import createNotificationDevice from '../../axios/posNotification/devices/post'
import updateNotificationDevice from '../../axios/posNotification/devices/put'

export const getNotificationDeviceThunk = (username, deviceId, token) => dispatch => {
	return getNotificationDevice(deviceId, username)
		.then(res => {
			const configId = res.data?.[0]?.id
			logger.info(`Get notification device:${res.data?.[0]}`)
			if (configId) {
				dispatch(updateNotificationDeviceThunk(configId, { token, active: true }))
			} else {
				dispatch(createNotificationDeviceThunk({ deviceId, token, active: true }))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const syncNotificationDeviceThunk = (username, deviceId, token) => dispatch => {
	return getNotificationDevice(deviceId, username)
		.then(res => {
			const configId = res.data?.[0]?.id
			logger.info(`Sync notification device configId:${res.data?.[0]}`)
			if (configId) {
				dispatch(updateNotificationDeviceThunk(configId, { token, active: true }))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateNotificationDeviceThunk = (id, data) => dispatch => {
	return updateNotificationDevice(id, data)
		.then((res) => {
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const createNotificationDeviceThunk = (data) => dispatch => {
	return createNotificationDevice(data)
		.then((res) => {
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
